<template>
  <div id="invite-records">
    <p class="little-title">
      <span :class="{ active: isRewardTab }" @click="isRewardTab = true">{{ $t('rewardCash') }}</span>
      <span :class="{ active: !isRewardTab }" @click="isRewardTab = false">{{ $t('friends') }}</span>
    </p>
    <div class="records-component">
      <reward-records-pc v-show="isRewardTab" class="pc-show" :init-award-records="initAwardRecords"></reward-records-pc>
      <reward-records-m v-show="isRewardTab" class="phone-show" :init-award-records="initAwardRecords"></reward-records-m>
      <friend-records-pc v-show="!isRewardTab" class="pc-show" :init-friend-records="initFriendRecords"></friend-records-pc>
      <friend-records-m v-show="!isRewardTab" class="phone-show" :init-friend-records="initFriendRecords"></friend-records-m>
    </div>
  </div>
</template>

<script>
  import FriendRecordsPc from '../friendRecords/FriendRecordsPc.vue'
  import FriendRecordsM from '../friendRecords/FriendRecordsM.vue'
  import RewardRecordsPc from '../rewardRecords/RewardRecordsPc.vue'
  import RewardRecordsM from '../rewardRecords/RewardRecordsM.vue'
  import locales from './lang'

  export default {
    name: 'commission-invite-record',
    components: {FriendRecordsPc, FriendRecordsM, RewardRecordsPc, RewardRecordsM},
    data() {
      return {
        isRewardTab: true,
        initFriendRecords: '',
        initAwardRecords: ''
      }
    },
    locales,
    computed: {
      language() {
        return this.$store.state.currentLang
      }
    },
    created() {
      this.getFriendRecords()
      this.getAwardRecords()
    },
    methods: {
      getFriendRecords() {
        this.$http.get('api/invitation-records/commission?page=1').then(response => {
          this.initFriendRecords = response.data
        })
      },
      getAwardRecords() {
        this.$http.get('api/commission-records?type=internal-award&page=1').then(response => {
          this.initAwardRecords = response.data
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/content-box";

  #invite-records {
    border: 1px solid #e0d7e3;
    border-radius: 8px;

    .little-title {
      font-size: 16px;
      color: #666;
      letter-spacing: 0;
      border-bottom: 1px solid #e0d7e3;
      padding: 0 0.16rem;
      line-height: .48rem;
      margin: 0;
      height: 0.48rem;
      position: relative;
      span {
        display: inline-block;
        line-height: .48rem;
        height: 0.48rem;
        cursor: pointer;
        &:nth-child(1) {
          margin-right: 0.24rem;
        }
        &.active {
          color: #111;
          background: linear-gradient(135deg, #416CF8 0%, #EC55FF 100%) center bottom/36px 3px no-repeat;
        }
      }
      a {
        width: 113px;
        height: 28px;
        line-height: 26px;
        border: 1px solid #416CF8;
        border-radius: 4px;
        font-size: 14px;
        color: #416CF8;
        cursor: pointer;
        text-align: center;
        position: absolute;
        right: 0.16rem;
        top: 0.1rem;
      }
    }
    
    @media (max-width: 767px) {
      border-radius: .05rem;
      .little-title {
        height: 44px;
        line-height: 44px;
        font-size: .14rem;
        span {
          height: 44px;
          line-height: 44px;
          &:nth-child(1) {
            margin-right: .16rem;
          }
          &.active {
            background-size: 32px 3px;
          }
        }
      }
    }
  }

  .records-component {
    @media (max-width: 767px) {
      padding: 0 .16rem;
      .pc-show {
        display: none;
      }
    }
    @media screen and (min-width: 768px) {
      .phone-show {
        display: none;
      }
    }
  }

</style>




// WEBPACK FOOTER //
// InviteRecord.vue?6d468ae8